import { ContentRecommendation } from '@/components/content/ContentRecommendation';
import { Grid, Skeleton, Stack } from '@mui/material';

const emsNameDesktop = 'DPV2FooterLinksDesktop';
const emsNameMobile = 'DPV2FooterLinksMobile';

export const FooterLinksDesktop = () => (
	<ContentRecommendation
		id={`footer-${emsNameDesktop}`}
		properties={{ emsName: emsNameDesktop }}
		withoutFrame
		loadingElement={
			<>
				<Grid item sm={3} md={3} lg={2}>
					<Skeleton variant="rectangular" width="100%" height="250px" />
				</Grid>
				<Grid item sm={3} md={3} lg={2}>
					<Skeleton variant="rectangular" width="100%" height="250px" />
				</Grid>
				<Grid item sm={3} md={3} lg={2}>
					<Skeleton variant="rectangular" width="100%" height="250px" />
				</Grid>
			</>
		}
	/>
);

export const FooterLinksMobile = () => (
	<ContentRecommendation
		id={`footer-${emsNameMobile}`}
		properties={{ emsName: emsNameMobile }}
		withoutFrame
		loadingElement={
			<Stack>
				<Skeleton variant="rectangular" width="100%" height="250px" />
			</Stack>
		}
	/>
);
